import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Employee } from 'src/app/models/Employees';
import { AuthService } from 'src/app/services/auth.service';
import { EmployeeSService } from 'src/app/services/modelService/employeeS.service';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { AlertService } from 'src/app/util/alert.service';
import { ToastService } from 'src/app/util/toast.service';

@Component({
  selector: 'app-pd-card',
  templateUrl: './pd-card.component.html',
  styleUrls: ['./pd-card.component.scss'],
})
export class PdCardComponent implements OnInit {
  @Input() emp: Employee = new Employee();
  @Input() showImage = true;
  @Input() showCreator;

  enlargeImage = false;
  creator: Employee;
  verifier: Employee;
  objectKeys = Object.keys;
  constructor(public empService: EmployeeSService, public whatsapp: WhatsappService, private alert: AlertService, private toast: ToastService, public auth: AuthService) { }

  ngOnInit() {

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['emp'] && changes['emp'].currentValue) {
      const currentEmp = changes['emp'].currentValue;
      const previousEmp = changes['emp'].previousValue;
      
      const prevCreatedBy = previousEmp ? previousEmp.created_by : null;
      if (currentEmp.created_by && currentEmp.created_by !== prevCreatedBy) {
        this.empService.getEmpByVariable("id", currentEmp.created_by).then(creator => {
          this.creator = creator;
          this.emp.creator = creator;
        });
      }
      
      const prevManagerId = previousEmp ? previousEmp.manager_id : null;
      if (currentEmp.manager_id && currentEmp.manager_id !== prevManagerId) {
        this.empService.getEmpByVariable("id", currentEmp.manager_id).then(verifier => {
          this.verifier = verifier;
        });
      }
    }
  }

  clickAddMobile() {
    this.alert.showTextAlert("Add mobile", null, "Mobile").then((value) => {
      if (value && value.length == 10) {
        this.empService.getEmpByVariable("user.user_pd.mobile", value).then((emp) => {
          if (emp) {
            this.toast.error("This mobile belongs to " + emp.user.name + ". Please add unique mobile or contact them to merge this profile");
          } else {
            this.emp.user.user_pd.mobile = value;
            this.emp.created_by = this.auth.loggedInEmployee.id;
            this.creator = this.auth.loggedInEmployee;
            this.empService.saveUser("user_pd", this.emp.user.user_pd);
            this.empService.saveObject(this.emp, false)
          }
        })
      } else {
        this.toast.error("Add 10 digit mobile number");
        this.clickAddMobile();
      }
    })
  }

  clickImage(url) {

  }
}
